import { Fragment } from 'react';

import { UseUserInfo } from '@domain/user/useUserInfo';
import { CatchInfoCard } from '../../../../../../Cards/CatchInfoCard/CatchInfoCard';
import { EmptyCatchInfoCard } from '../../../../../../Cards/CatchInfoCard/EmptyCatchInfoCard';
import type { CatchConditions } from '../../../../../types/CatchConditions';

import { getCatchesInfoCardsData } from './getCatchesInfoCardsData';

interface PremiumCatchInfoCardsProps {
  catchConditions: CatchConditions;
  currentUser: UseUserInfo;
}

export const PremiumCatchInfoCards = ({
  catchConditions,
  currentUser,
}: PremiumCatchInfoCardsProps) => {
  const catchesInfoCardsData = getCatchesInfoCardsData(catchConditions, currentUser);

  return (
    <div className="grid grid-cols-3 gap-2">
      {catchesInfoCardsData.map(
        ({ bottomText, cardDescription, iconComponent, iconText, shouldRenderCatchInfoCard }) => (
          <Fragment key={cardDescription}>
            {shouldRenderCatchInfoCard ? (
              <CatchInfoCard
                bottomText={bottomText}
                iconComponent={iconComponent}
                iconText={iconText}
              />
            ) : (
              <EmptyCatchInfoCard cardDescription={cardDescription} />
            )}
          </Fragment>
        ),
      )}
    </div>
  );
};
